import { useTranslation } from "react-i18next";
import { ResponsiveDropdownItem } from "@components";
import AddIcon from "@icons/myicons/plus.svg?react";
import EditIcon from "@icons/myicons/edit.svg?react";
import CancelIcon from "@icons/myicons/delete-circle.svg?react";

interface Options {
  investmentId: number;
  handleOpenDeleteModal: () => void;
}

export const useInvestmentMenuItems = ({
  investmentId,
  handleOpenDeleteModal,
}: Options): ResponsiveDropdownItem[] => {
  const { t } = useTranslation();

  return [
    {
      label: t("investment.header.actions.addBookingButton"),
      testId: "add-booking",
      to: `/add-transaction-wizard/${investmentId}`,
      icon: <AddIcon width="24px" height="14px" />,
    },
    {
      label: t("investment.header.actions.editInvestmentButton"),
      testId: "investment-edit-menu-item",
      to: `/investments/${investmentId}/edit`,
      icon: <EditIcon />,
    },
    {
      label: t("investment.header.actions.deleteInvestmentButton"),
      testId: "delete",
      onClick: handleOpenDeleteModal,
      icon: <CancelIcon />,
      color: "error.main",
      startsGroup: true,
    },
  ];
};
